import toLocaleTime from '@sv-support-sdk/utils/src/helpers/toLocaleTime';
import getReplyFromMessage from '@sv-support-sdk/utils/src/helpers/getReplyFromMessage';
import fileSizeFormat from '@sv-support-sdk/utils/src/helpers/fileSizeFormat';
import { chatsSelectors } from '@sv-support-sdk/store';
import { IMessage, TStaffAvatar } from '@sv-support-sdk/shared-types/src/common/chats';
import { IAttachment } from '@sv-support-sdk/shared-types/src/common/tickets';

import { RootState } from '..';

export const { selectChats, selectChatsMeta, selectChatsLoading, selectSelectedChatLoading } =
  chatsSelectors;

const transformMessageForRendering = (message: IMessage) => {
  const additionalFields: {
    createdAtToShow: string;
    avatar?: TStaffAvatar;
    isFromUser: boolean;
    attachments?: IAttachment[];
  } = {
    createdAtToShow: toLocaleTime(message.createdAt, 'hh:mm A'),
    isFromUser: message.authorType !== 'staff',
    ...getReplyFromMessage(message.message),
  };

  if (message.authorType === 'staff') {
    additionalFields.avatar = message.staffAvatar
      ? { img: { src: message.staffAvatar, alt: message.authorName } }
      : { icon: 'colored--32--support-agent', size: '32' };
  }

  if (message.attachments.length) {
    additionalFields.attachments = message.attachments.map((attachment) => {
      return {
        ...attachment,
        size: fileSizeFormat(Number(attachment.size)),
      };
    });
  }

  return {
    ...message,
    ...additionalFields,
  };
};

export const selectChat = (state: RootState) => {
  const { selectedChat } = state.chats;

  return selectedChat
    ? {
        ...selectedChat,
        createdAt: toLocaleTime(selectedChat.messages[0].createdAt),
        messages: selectedChat.messages.map(transformMessageForRendering),
      }
    : null;
};
